export enum ContextMenuValues {
  Comments = 'comments',
  GenAi = 'gen-ai',
  TagAClause = 'tag-a-clause',
}
